import(/* webpackMode: "eager" */ "/vercel/path0/packages/portfolio-frontend/src/app/layout.tsx");
